import { render, staticRenderFns } from "./ImageTemplate.vue?vue&type=template&id=66074f36&scoped=true&"
import script from "./ImageTemplate.vue?vue&type=script&lang=js&"
export * from "./ImageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ImageTemplate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImageTemplate.vue?vue&type=style&index=1&id=66074f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66074f36",
  null
  
)

export default component.exports